module.exports = __webpack_public_path__ + "img/WeChat26284575ae9854426ebcf1401f6a4b50.26284575.png";